// 库存状态: 33(现货) / 39(在途) / 40(内配) / 36(预订) / 34(无货)
export const IN_STOCK_STATUS_TYPES = [33, 36, 39, 40];

export const isInStockStatus = (stockStatusType: number | string | null | undefined) =>
  IN_STOCK_STATUS_TYPES.includes(Number(stockStatusType));

export const getIsInStock = (stockStatusType: number | string | null | undefined) =>
  (isInStockStatus(stockStatusType) ? 1 : 0);
